<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Parent Category</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Parent Category</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="ParentCategory">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'ParentCategoryList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <el-tabs type="border-card">
                    <el-tab-pane label="Parent Category">
                      <div class="form-group required">
                        <label class="control-label" for="title"
                          >Title (English)</label
                        >
                        <input
                          type="text"
                          id="title"
                          name="title"
                          v-bind:class="{ 'has-error': errors.has('title') }"
                          v-validate="'required'"
                          v-model="value.title"
                          @change="slug($event)"
                          class="form-control"
                          placeholder="Title (English)"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('title')"
                        >
                          {{ errors.first("title") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="title_bn" class="control-label"
                          >Title (Bangla)</label
                        >
                        <input
                          type="text"
                          id="title_bn"
                          name="title_bn"
                          v-bind:class="{ 'has-error': errors.has('title_bn') }"
                          v-model="value.title_bn"
                          class="form-control title_bn"
                          placeholder="Title (Bangla)"
                        />
                      </div>
                      <div class="form-group required">
                        <label class="control-label" for="slug">Slug</label>
                        <input
                          type="text"
                          id="slug"
                          name="slug"
                          v-bind:class="{ 'has-error': errors.has('slug') }"
                          v-validate="'required'"
                          v-model="value.slug"
                          class="form-control"
                          placeholder="Slug"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('slug')"
                        >
                          {{ errors.first("slug") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label" for="description"
                          >Description (English)</label
                        >
                        <textarea
                          id="description"
                          name="description"
                          v-model="value.description"
                          class="form-control"
                          placeholder="Description (English)"
                          rows="3"
                        ></textarea>
                        <div
                          class="help text-danger"
                          v-show="errors.has('description')"
                        >
                          {{ errors.first("description") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label" for="description_bn"
                          >Description (Bangla)</label
                        >
                        <textarea
                          id="description_bn"
                          name="description_bn"
                          v-model="value.description_bn"
                          class="form-control"
                          placeholder="Description (Bangla)"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group required">
                        <label for="thumbnail" class="control-label"
                          >Thumbnail</label
                        >
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="thumbnail"
                                  class="custom-file-input"
                                  id="thumbnail"
                                  @change="selectFile"
                                  accept="image/png, image/jpeg, image/jpg"
                                />
                                <label
                                  class="custom-file-label"
                                  for="meta_image"
                                >
                                  {{ value.thumbnail_name }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-8">
                            <img
                              alt="preview image"
                              v-if="temp_thumbnail"
                              v-bind:src="temp_thumbnail"
                              width="100"
                              height="100"
                              class="img-thumbnail"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Display order</label>
                        <input
                          type="number"
                          id="display_order"
                          name="display_order"
                          v-bind:class="{
                            'has-error': errors.has('display_order'),
                          }"
                          v-validate="'required|min:0|max:9999'"
                          v-model="value.display_order"
                          class="form-control"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('display_order')"
                        >
                          {{ errors.first("display_order") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Is featured</label>
                        <br />
                        <el-select
                          v-model="value.is_featured"
                          name="is_featured"
                          placeholder="Select"
                          v-validate="'required'"
                        >
                          <el-option
                            v-for="item in [
                              { value: 1, label: 'Yes' },
                              { value: 0, label: 'No' },
                            ]"
                            :key="item.value"
                            v-bind:class="{
                              'has-error': errors.has('is_featured'),
                            }"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <div
                          class="help text-danger"
                          v-show="errors.has('is_featured')"
                        >
                          {{ errors.first("is_featured") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Is published</label>
                        <div class="form-group">
                          <el-select
                            v-model="value.is_published"
                            placeholder="Select"
                            name="is_published"
                          >
                            <el-option
                              v-for="item in [
                                { value: 1, label: 'Published' },
                                { value: 0, label: 'Not published' },
                              ]"
                              :key="item.value"
                              v-bind:class="{
                                'has-error': errors.has('is_published'),
                              }"
                              v-validate="'required'"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                          <div
                            class="help text-danger"
                            v-show="errors.has('is_published')"
                          >
                            {{ errors.first("is_published") }}
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="SEO Meta">
                      <div class="form-group">
                        <label class="control-label" for="meta_title"
                          >Meta title</label
                        >
                        <input
                          type="text"
                          id="meta_title"
                          name="blog_seo_title"
                          v-model="value.meta_data.meta_title"
                          class="form-control"
                          placeholder="Meta title"
                        />
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Meta image</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="meta_image"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="meta_image"
                                  class="custom-file-input"
                                  id="meta_image"
                                  accept="image/png, image/jpeg, image/jpg"
                                  @change="selectFileSeoImage"
                                />
                                <label
                                  class="custom-file-label"
                                  for="meta_image"
                                >
                                  {{ value.meta_data.meta_image_name }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-8">
                            <img
                              alt="preview image"
                              v-if="temp_meta_thumbnail"
                              v-bind:src="temp_meta_thumbnail"
                              width="100"
                              height="100"
                              class="img-thumbnail"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label" for="meta_description"
                          >Meta description</label
                        >
                        <textarea
                          id="meta_description"
                          name="meta_description"
                          v-model="value.meta_data.meta_description"
                          class="form-control"
                          placeholder="Meta description"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="control-label" for="meta_keywords"
                          >Meta keywords</label
                        >
                        <input
                          type="text"
                          id="meta_keywords"
                          name="meta_keywords"
                          v-model="value.meta_data.meta_keywords"
                          class="form-control"
                          placeholder="Meta Keywords"
                        />
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ParentCategoryForm",
  metaInfo: {
    title: "Parent Category | Dotlines",
  },
  data: () => ({
    is_loading: false,
    is_edit: false,
    temp_thumbnail: "",
    temp_meta_thumbnail: "",
    params: {},
    value: {
      title: "",
      title_bn: "",
      slug: "",
      description: "",
      description_bn: "",
      display_order: 9999,
      thumbnail: "",
      thumbnail_name: "Choose file",
      meta_data: {
        meta_title: "",
        meta_description: "",
        meta_keywords: "",
        meta_image: "",
        meta_image_name: "Choose file",
      },
    },
  }),
  methods: {
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/parent_categories";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/parent_categories/" + _this.$route.params.id;
            method = "PUT";
          }
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "ParentCategoryList" });
            })
            .catch((errors) => {
              _this.$toaster.error(errors.response.data.message);
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/parent_categories/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.value.thumbnail = reader.result;
        this.temp_thumbnail = reader.result;
        this.$set(this.value, "thumbnail_name", event.target.files[0].name);
      };
    },

    selectFileSeoImage: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.value.meta_data.meta_image = reader.result;
          this.temp_meta_thumbnail = reader.result;
          this.$set(
            this.value.meta_data,
            "meta_image_name",
            event.target.files[0].name
          );
        };
      } catch (e) {
        //console.log(e);
      }
    },

    slug(event) {
      let title = event.target.value;
      this.value.slug = title.replace(/\s+/g, "-").toLowerCase();
    },

    async initialize() {
      let _this = this;
      _this.is_loading = true;
      _this.params = _this.$route.params;
      if (!_.isEmpty(_this.params) && _this.params.id !== undefined) {
        _this.is_edit = true;
      }
      if (_this.is_edit) {
        await _this
          .getDetail(this.params.id)
          .then((response) => {
            _this.value = response.data;
            let asset_get_url = this.API_ASSET_UPLOAD_URL + "/";
            _this.temp_thumbnail = asset_get_url + _this.value.thumbnail;
            _this.temp_meta_thumbnail =
              asset_get_url + _this.value.meta_data.meta_image;
            _this.value.thumbnail = "";
            _this.value.meta_data.meta_image = "";
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
      _this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
